import PropTypes from 'prop-types';
import React from 'react';
import { UncomposedTableView } from '../tableView';
const FOLLOWUP_EVIDENCE_TABLE_PATH = 'followup-analysis-evidence';
const noopTableViewOnChange = () => {};
const FollowupAnalysisResults = ({
  followup,
  followupId
}) => {
  var _followup$analysis, _followup$analysis2;
  const hasExecutionRows = ((_followup$analysis = followup.analysis) === null || _followup$analysis === void 0 || (_followup$analysis = _followup$analysis.execution) === null || _followup$analysis === void 0 || (_followup$analysis = _followup$analysis.rows) === null || _followup$analysis === void 0 ? void 0 : _followup$analysis.length) > 0;
  const execution = (_followup$analysis2 = followup.analysis) === null || _followup$analysis2 === void 0 ? void 0 : _followup$analysis2.execution;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-muted small"
  }, "Analysis Summary"), /*#__PURE__*/React.createElement("div", {
    className: "fw-medium"
  }, followup.analysis.summary)), hasExecutionRows && execution && /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(UncomposedTableView, {
    path: FOLLOWUP_EVIDENCE_TABLE_PATH,
    label: "Evidence",
    value: {
      rows: execution.rows,
      rowCount: execution.rowCount
    },
    onChange: noopTableViewOnChange,
    showRowCount: true,
    maxRows: 5,
    downloadFileName: `followup-${followupId}-evidence`,
    showDownloadButton: true,
    postActions: []
  })), followup.analysis.recommendations && /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-muted small"
  }, "Recommendations"), /*#__PURE__*/React.createElement("div", {
    className: "fw-medium",
    style: {
      whiteSpace: 'pre-wrap'
    }
  }, followup.analysis.recommendations)));
};
FollowupAnalysisResults.propTypes = {
  followup: PropTypes.shape({
    analysis: PropTypes.shape({
      summary: PropTypes.string,
      execution: PropTypes.shape({
        rows: PropTypes.arrayOf(PropTypes.shape({})),
        rowCount: PropTypes.number
      }),
      recommendations: PropTypes.string
    })
  }).isRequired,
  followupId: PropTypes.string.isRequired
};
export default FollowupAnalysisResults;